import { AddressInfo } from 'models/restaurant'
import { StatsCard, ProgressChart } from './index'
import {
  formatCurrency,
  formatPercentageValue,
  formatPopulationDensity,
} from 'utils/formatting'
import {
  getRaceData,
  getAgeData,
  getEducationData,
  getHighIncomePercentage,
} from 'utils/demographics'

interface DemographicsSectionProps {
  addressInfo: AddressInfo
}

export function DemographicsSection({ addressInfo }: DemographicsSectionProps) {
  // Basic demographics stats
  const basicStats = [
    {
      label: 'Median HH Income',
      value: formatCurrency(
        addressInfo.income_medianhouseholdincome_hh_cnt || 0
      ),
    },
    {
      label: 'Population Density',
      value: formatPopulationDensity(addressInfo.pop_sqmi || 0),
    },
    {
      label: 'HH Income $100k+',
      value: formatPercentageValue(getHighIncomePercentage(addressInfo)),
    },
    {
      label: 'Unemployment Rate',
      value: formatPercentageValue(
        addressInfo.employment_unemployed_rate_county_level_only_pct || 0
      ),
    },
  ]

  // Get demographic data using utility functions
  const raceData = getRaceData(addressInfo)
  const ageData = getAgeData(addressInfo)
  const educationData = getEducationData(addressInfo)

  return (
    <div className="flex flex-col gap-6">
      {/* Basic Demographics Stats */}
      <div className="bg-white rounded-lg">
        <div className="text-sm font-medium text-gray-900 mb-3">
          ZIP Code Demographics
        </div>
        <StatsCard stats={basicStats} />
      </div>

      {/* Race Demographics Chart */}
      <ProgressChart
        title="Race"
        items={raceData}
        showScale={true}
        legend={{
          showPercentages: true,
          columns: 1,
        }}
        className="bg-gray-50 rounded-lg p-3"
      />

      {/* Age Demographics Chart */}
      <ProgressChart
        title="Age"
        items={ageData}
        showScale={true}
        legend={{
          showPercentages: true,
          columns: 1,
        }}
        className="bg-gray-50 rounded-lg p-3"
      />

      {/* Education Demographics Chart */}
      <ProgressChart
        title="Education"
        items={educationData}
        showScale={true}
        legend={{
          showPercentages: true,
          columns: 1,
        }}
        className="bg-gray-50 rounded-lg p-3"
      />
    </div>
  )
}
